module.exports = __webpack_public_path__ + "media/images/regional-image10-e698b565ce13aebd9e3d247c80f801ac.jpg";